<ng-container>
  <div class="chart-outer-wrapper">
    <div class="chart-wrapper">
      <ng-container *ngTemplateOutlet="gwpChart"></ng-container>
    </div>
    <div class="chart-wrapper">
      <ng-container *ngTemplateOutlet="materialHotspot"></ng-container>
    </div>
  </div>
</ng-container>

<!-- Common Chart Content (No Repetition) -->
<ng-template #gwpChart>
  <div class="header-content">
    <div class="title-content">
      <h6 [title]="donutChartData?.name">{{ donutChartData?.name }}</h6>
      <p>{{ donutChartData?.unit }}</p>
    </div>
    <mds-icon
      [key]="icons.FILTER_CHART"
      [width]="20"
      [height]="20"
      [inline]="true"
      class="right-icon-margin"
    ></mds-icon>
  </div>
  <div class="chart-wrapper__inline-container">
    @if (gwpLoading) {
      <mds-loader></mds-loader>
    }
    @if (!gwpLoading) {
      @if (isEmptyGWP) {
        <app-empty-chart [title]="emptyChart.title" [description]="emptyChart.description"></app-empty-chart>
      }
      @if (chartOptions && !isEmptyGWP) {
        <div class="chart-content">
          <highcharts-chart
            class="chart-1"
            [Highcharts]="Highcharts"
            [options]="chartOptions"
            [oneToOne]="true"
          ></highcharts-chart>
        </div>
      }
    }
  </div>
</ng-template>

<!-- Material Chart Content (No Repetition) -->
<ng-template #materialHotspot>
  <div class="header-content">
    <div class="title-content">
      <h6 [title]="pieChartData?.name">{{ pieChartData?.name }}</h6>
      <p>{{ pieChartData?.unit }}</p>
    </div>
  </div>
  <div class="chart-wrapper__inline-container">
    @if (hotspotsLoading) {
      <mds-loader></mds-loader>
    }
    @if (!hotspotsLoading) {
      @if (isEmptyHotspot) {
        <app-empty-chart [title]="emptyChart.title" [description]="emptyChart.description"></app-empty-chart>
      }
      @if (hotspotChartOptions && !isEmptyHotspot) {
        <div class="chart-content">
          <highcharts-chart
            class="chart-1"
            [Highcharts]="Highcharts"
            [options]="hotspotChartOptions"
            [oneToOne]="true"
          ></highcharts-chart>
        </div>
      }
    }
  </div>
</ng-template>
